import React, { useContext, useRef, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import ServiceLogo from 'assets/images/Dashboard/Logo.png';
import AddBlackColor from 'assets/images/Dashboard/addBlackColor.png';
import ReusableButton from 'components/common/Button';
import MuiBreadcrumbs from 'components/common/MuiBreadcrumbs';
import { superAdminCategory } from 'routes/AppUrls';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import leftArrow from 'assets/images/Dashboard/arrow-left.png';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import SwitchInput from 'components/common/Input/SwitchInput';
import CheckValidation from 'utils/Validation';
import { useDispatch, useSelector } from 'react-redux';
import { addCategoryCallAPI } from 'store/SuperAdmin/addCategory/action';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import ToastNotification from 'components/common/Toast';
import CircularProgress from '@mui/material/CircularProgress';
import MultiSelectChip from 'components/common/Input/MultiSelectChip';
import { imageUploadCallAPI } from 'store/ImageUpload/action';

import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

const AddCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const imageRef = useRef();
  const iconRef = useRef();
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);
  const [description, setDescription] = useState(false);
  const [checked, setChecked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [conf, setConf] = ToastNotification();

  const [srcIcon, setSrcIcon] = useState(null);
  const [cropIcon, setCropIcon] = useState({
    unit: 'px', // pixel unit
    width: 70,
    height: 70,
    x: 0,
    y: 0,
  });

  const [iconImage, setIconImage] = useState(null);
  const [isIconModalOpen, setIsIconModalOpen] = useState(false);

  const addCategoryLoader = useSelector(
    (state) => state?.addCategoryReducer?.loading
  );

  const [formValue, setFormValue] = useState({
    categoryNameEn: '',
    image: '',
    icon: '',
    productsUsedEn: '',
    benefitsEn: '',
    procedureEn: '',
    precautionsEn: '',
    thingsToKnowEn: '',
    afterCareTipsEn: '',
    categoryNameAr: '',
    productsUsedAr: '',
    benefitsAr: '',
    procedureAr: '',
    precautionsAr: '',
    thingsToKnowAr: '',
    afterCareTipsAr: '',
  });

  const [formId, setFormId] = useState({
    image: '',
  });

  const [previewFile, setPreviewFile] = useState({
    image: '',
    icon: '',
  });

  const [htmlValues, setHtmlValues] = useState({
    productsUsedEn: '',
    benefitsEn: '',
    procedureEn: '',
    precautionsEn: '',
    thingsToKnowEn: '',
    afterCareTipsEn: '',
    productsUsedAr: '',
    benefitsAr: '',
    procedureAr: '',
    precautionsAr: '',
    thingsToKnowAr: '',
    afterCareTipsAr: '',
  });

  const [breadcrumbsList, setBreadcrumbsList] = useState([
    {
      title: <FormattedMessage id="Service Categories" />,
      Link: superAdminCategory(locale),
      isDisbale: false,
    },
    {
      title: <FormattedMessage id="Add Category" />,
      Link: '',
      isDisbale: true,
    },
  ]);

  const onEditorStateChange = (editorState, name) => {
    const htmlContent = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    setHtmlValues((prev) => ({
      ...prev,
      [name]: editorState,
    }));
    setFormValue((prev) => ({
      ...prev,
      [name]: htmlContent,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSwitchChange = (event) => {
    setChecked(!checked);
  };

  const handleIconUpload = () => {
    iconRef.current.click();
  };

  const handleImageUpload = () => {
    imageRef.current.click();
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;

    if (files?.length > 0) {
      if (name === 'image') {
        handleUploadImage(e);
      } else {
        handleUploadIconImage(files[0]);
        setIsIconModalOpen(true);
      }
    }

    e.target.value = null;
  };

  const handleUploadIconImage = (file) => {
    const reader = new FileReader();
    reader.onload = () => setSrcIcon(reader.result);
    reader.readAsDataURL(file);
  };

  const getCroppedIcon = () => {
    if (!iconImage) return;

    const canvas = document.createElement('canvas');
    const scaleX = iconImage.naturalWidth / iconImage.width;
    const scaleY = iconImage.naturalHeight / iconImage.height;
    canvas.width = 70;
    canvas.height = 70;
    const ctx = canvas.getContext('2d');

    ctx.drawImage(
      iconImage,
      cropIcon.x * scaleX,
      cropIcon.y * scaleY,
      cropIcon.width * scaleX,
      cropIcon.height * scaleY,
      0,
      0,
      70,
      70
    );

    canvas.toBlob((blob) => {
      if (blob) {
        const fileUrl = URL.createObjectURL(blob);
        setFormValue((prev) => ({
          ...prev,
          ['icon']: blob,
        }));

        setPreviewFile((prev) => ({
          ...prev,
          ['icon']: fileUrl,
        }));

        setIsIconModalOpen(false);

        iconRef.current.value = null;
      }
    }, 'image/png');
  };

  const handleUploadImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      let formData = new FormData();
      formData.append('filePath', file);
      formData.append('fileType', 'I');
      dispatch(
        imageUploadCallAPI(formData, {
          navigate: navigate,
          run: true,
          handleFunction: (res) => handleImagesSuccess(res, file),
        })
      );
    }
  };

  const handleImagesSuccess = (res, file) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    setFormValue((prev) => ({
      ...prev,
      ['image']: file,
    }));
    setPreviewFile((prev) => ({
      ...prev,
      ['image']: URL.createObjectURL(file),
    }));
    setFormId((prev) => ({
      ...prev,
      ['image']: res?.data?.data?.[0]?.id,
    }));
  };

  const handleSubmit = () => {
    const { categoryNameEn, categoryNameAr, icon, image } = formValue;
    // const error = CheckValidation({ categoryNameEn, categoryNameAr, image });
    const error = checked
      ? CheckValidation({ categoryNameAr, icon, image })
      : CheckValidation({ categoryNameEn, icon, image });
    setIsError(error);
    if (error.submit) {
      const formData = new FormData();
      formData.append('name', formValue?.categoryNameEn || '');
      formData.append('image', formValue?.icon);
      formData.append('category_image_id', formId?.image);
      formData.append('name_ar', formValue?.categoryNameAr || '');
      formData.append('title_ar', formValue?.categoryNameAr || '');
      formData.append('material_used_en', formValue?.productsUsedEn || '');
      formData.append('material_used_ar', formValue?.productsUsedAr || '');
      formData.append('benefits_en', formValue?.benefitsEn || '');
      formData.append('benefits_ar', formValue?.benefitsAr || '');
      formData.append('procedure_en', formValue?.procedureEn || '');
      formData.append('procedure_ar', formValue?.procedureAr || '');
      formData.append('precautions_en', formValue?.precautionsEn || '');
      formData.append('precautions_ar', formValue?.precautionsAr || '');
      formData.append('things_to_know_en', formValue?.thingsToKnowEn || '');
      formData.append('things_to_know_ar', formValue?.thingsToKnowAr || '');
      formData.append('after_care_tips_en', formValue?.afterCareTipsEn || '');
      formData.append('after_care_tips_ar', formValue?.afterCareTipsAr || '');

      dispatch(
        addCategoryCallAPI(formData, {
          run: true,
          handleFunction: (res) => handleRedirect(res),
          toast: true,
          handleToastError: (res) => handleToastError(res),
          navigate: navigate,
        })
      );
    }
  };

  const handleRedirect = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    setTimeout(() => {
      navigate(superAdminCategory(locale));
    }, 1000);
  };

  const handleToastError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <MuiBreadcrumbs size="14" list={breadcrumbsList} />
        <Row className="bc-FFFFFF m-0 p-16 mt-3">
          <div className="flex justify-between items-center">
            <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
              <Stack direction="horizontal" gap={2} className="items-center">
                <img
                  src={leftArrow}
                  alt="icon"
                  style={{ height: '32px', width: '32px' }}
                  className="cursor-pointer"
                  onClick={() => navigate(superAdminCategory(locale))}
                />
                <p className="p-0 m-0">
                  <FormattedMessage id="Add Category" />
                </p>
              </Stack>
            </h2>
            <img
              src={ServiceLogo}
              alt={'logo'}
              style={{ height: '64px', width: '96px' }}
            />
          </div>

          <>
            <Row className="m-0 p-0">
              <div className="grid justify-end text-end">
                <SwitchInput
                  label={'En/Ar'}
                  checked={checked}
                  onChange={(e) => handleSwitchChange(e)}
                  color="secondary"
                />
              </div>
            </Row>

            {!checked ? (
              <>
                <Row className="m-0 p-0">
                  <Col xs={12} md={6}>
                    <LabelWithInput
                      label={<FormattedMessage id="CategoryNameEn" />}
                      required={true}
                      placeholder={intl.formatMessage({
                        id: 'CategoryNameEn',
                      })}
                      name="categoryNameEn"
                      type="text"
                      value={formValue?.categoryNameEn}
                      onChange={handleInputChange}
                      errorText={
                        isError &&
                        isError.categoryNameEn.error &&
                        isError.categoryNameEn.errorMessage
                      }
                    />
                  </Col>

                  <Col xs={12} md={6} className="pt-15">
                    <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="IconEn" />{' '}
                      <span
                        style={{
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        *
                      </span>
                    </p>
                    <input
                      ref={iconRef}
                      type="file"
                      name="icon"
                      accept=".png, .jpg, .jpeg"
                      disabled={false}
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                    />

                    <div
                      className={`mt-2 ${isError && isError?.icon?.error ? 'imageRedBorder' : 'imageBorder'} flex justify-center align-center`}
                    >
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center cursor-pointer"
                        onClick={handleIconUpload}
                      >
                        {formValue?.icon === '' ? (
                          <>
                            <img
                              src={AddBlackColor}
                              alt="icon"
                              style={{ height: '24px', width: '24px' }}
                            />
                            <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                              <FormattedMessage id="AddIconEn" />
                            </p>
                          </>
                        ) : (
                          <>
                            <img
                              src={previewFile?.icon}
                              alt="icon"
                              style={{ height: '50px', width: '50px' }}
                            />
                            <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                              {formValue?.icon?.name}
                            </p>
                          </>
                        )}
                      </Stack>
                    </div>
                    {isIconModalOpen && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-index-99">
                        <div className="bg-white p-4 rounded-lg shadow-lg w-[400px]">
                          <h2 className="text-lg ff-Akkurat_Bold mb-2">
                            <FormattedMessage id="CropImageEn" />
                          </h2>

                          {srcIcon && (
                            <ReactCrop
                              crop={cropIcon}
                              className="react-manully-crop"
                              onChange={(newCrop) =>
                                setCropIcon({
                                  ...cropIcon,
                                  x: newCrop.x,
                                  y: newCrop.y,
                                })
                              }
                              locked
                              keepSelection
                            >
                              <img
                                src={srcIcon}
                                alt="Upload"
                                onLoad={(e) => setIconImage(e.currentTarget)}
                              />
                            </ReactCrop>
                          )}

                          <div className="flex justify-end mt-4 gap-2">
                            <ReusableButton
                              fullWidth={false}
                              variant="outlined"
                              color="#292D32"
                              fontSize="16px"
                              fontWeight="400"
                              padding="12px 25px"
                              height="44px"
                              bgColor="transparent"
                              fontFamily="Akkurat"
                              onClick={() => {
                                setIsIconModalOpen(false);
                                setSrcIcon(null);
                                setIconImage(null);
                                setCropIcon({
                                  unit: 'px',
                                  width: 70,
                                  height: 70,
                                  x: 0,
                                  y: 0,
                                });
                              }}
                            >
                              <FormattedMessage id="CancelEn" />
                            </ReusableButton>

                            <ReusableButton
                              fullWidth={false}
                              variant="contained"
                              color="#F5F5F5"
                              fontSize="16px"
                              fontWeight="400"
                              padding="12px 25px"
                              height="44px"
                              bgColor="#292D32"
                              fontFamily="Akkurat"
                              onClick={() => getCroppedIcon()}
                            >
                              <FormattedMessage id="SaveCropEn" />
                            </ReusableButton>
                          </div>
                        </div>
                      </div>
                    )}
                    {isError && isError?.icon?.error && (
                      <div style={{ marginTop: '5px' }}>
                        <p className="p-0 m-0 fs-16 fc-EE3232 fw-400 ff-Akkurat">
                          <FormattedMessage id="field is required!" />
                        </p>
                      </div>
                    )}
                  </Col>

                  <Col xs={12} md={6} className="mt-3 pt-15">
                    <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="ImageEn" />{' '}
                      <span
                        style={{
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        *
                      </span>
                    </p>
                    <input
                      ref={imageRef}
                      type="file"
                      name="image"
                      accept=".png, .jpg, .jpeg"
                      disabled={false}
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                    />
                    <div
                      className={`mt-2 ${isError && isError.image.error ? 'imageRedBorder' : 'imageBorder'} flex justify-center align-center`}
                    >
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center cursor-pointer"
                        onClick={handleImageUpload}
                      >
                        {formValue?.image === '' ? (
                          <>
                            <img
                              src={AddBlackColor}
                              alt="icon"
                              style={{ height: '24px', width: '24px' }}
                            />
                            <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                              <FormattedMessage id="AddImageEn" />
                            </p>
                          </>
                        ) : (
                          <>
                            <img
                              src={previewFile?.image}
                              alt="icon"
                              style={{ height: '50px', width: '50px' }}
                            />
                            <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                              {formValue?.image?.name}
                            </p>
                          </>
                        )}
                      </Stack>
                    </div>
                    {isError && isError?.image?.error && (
                      <div style={{ marginTop: '5px' }}>
                        <p className="p-0 m-0 fs-16 fc-EE3232 fw-400 ff-Akkurat">
                          <FormattedMessage id="field is required!" />
                        </p>
                      </div>
                    )}
                  </Col>

                  <Col xs={12} md={6} className="mt-3 pt-15"></Col>

                  <Col xs={12} md={3} className="mt-3 pt-15">
                    <p className="p-0 m-0 fs-20 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="DescriptionEn" />
                    </p>
                    {!description && (
                      <div
                        className="mt-2 imageBorderWithoutDashed flex justify-center align-center cursor-pointer"
                        onClick={() => setDescription(!description)}
                      >
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center"
                        >
                          <img
                            src={AddBlackColor}
                            alt="icon"
                            style={{ height: '24px', width: '24px' }}
                          />
                          <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                            <FormattedMessage id="AddDescriptionEn" />
                          </p>
                        </Stack>
                      </div>
                    )}
                  </Col>
                </Row>

                {description && (
                  <>
                    <Col xs={12} md={12} className="mt-2">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="ProductsusedEn" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.productsUsedEn}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'productsUsedEn')
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="BenefitsEn" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.benefitsEn}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'benefitsEn')
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="ProcedureEn" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.procedureEn}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'procedureEn')
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="PrecautionsEn" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.precautionsEn}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'precautionsEn')
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="ThingstoknowEn" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.thingsToKnowEn}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'thingsToKnowEn')
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="AftercaretipsEn" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.afterCareTipsEn}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'afterCareTipsEn')
                          }
                        />
                      </div>
                    </Col>
                  </>
                )}
              </>
            ) : (
              <>
                <Row className="m-0 p-0">
                  <Col xs={12} md={6}>
                    <LabelWithInput
                      label={<FormattedMessage id="CategoryNameAr" />}
                      required={true}
                      placeholder={intl.formatMessage({
                        id: 'CategoryNameAr',
                      })}
                      name="categoryNameAr"
                      type="text"
                      value={formValue?.categoryNameAr}
                      onChange={handleInputChange}
                      errorText={
                        isError &&
                        isError.categoryNameAr.error &&
                        isError.categoryNameAr.errorMessage
                      }
                    />
                  </Col>

                  <Col xs={12} md={6} className="pt-15">
                    <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="IconAr" />{' '}
                      <span
                        style={{
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        *
                      </span>
                    </p>
                    <input
                      ref={iconRef}
                      type="file"
                      name="icon"
                      accept=".png, .jpg, .jpeg"
                      disabled={false}
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                    />
                    <div
                      className={`mt-2 ${isError && isError?.icon?.error ? 'imageRedBorder' : 'imageBorder'} flex justify-center align-center`}
                    >
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center cursor-pointer"
                        onClick={handleIconUpload}
                      >
                        {formValue?.icon === '' ? (
                          <>
                            <img
                              src={AddBlackColor}
                              alt="icon"
                              style={{ height: '24px', width: '24px' }}
                            />
                            <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                              <FormattedMessage id="AddIconAr" />
                            </p>
                          </>
                        ) : (
                          <>
                            <img
                              src={previewFile?.icon}
                              alt="icon"
                              style={{ height: '50px', width: '50px' }}
                            />
                            <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                              {formValue?.icon?.name}
                            </p>
                          </>
                        )}
                      </Stack>
                    </div>
                    {isIconModalOpen && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-index-99">
                        <div className="bg-white p-4 rounded-lg shadow-lg w-[400px]">
                          <h2 className="text-lg ff-Akkurat_Bold mb-2">
                            <FormattedMessage id="CropImageAr" />
                          </h2>

                          {srcIcon && (
                            <ReactCrop
                              crop={cropIcon}
                              className="react-manully-crop"
                              onChange={(newCrop) =>
                                setCropIcon({
                                  ...cropIcon,
                                  x: newCrop.x,
                                  y: newCrop.y,
                                })
                              }
                              locked
                              keepSelection
                            >
                              <img
                                src={srcIcon}
                                alt="Upload"
                                onLoad={(e) => setIconImage(e.currentTarget)}
                              />
                            </ReactCrop>
                          )}

                          <div className="flex justify-end mt-4 gap-2">
                            <ReusableButton
                              fullWidth={false}
                              variant="outlined"
                              color="#292D32"
                              fontSize="16px"
                              fontWeight="400"
                              padding="12px 25px"
                              height="44px"
                              bgColor="transparent"
                              fontFamily="Akkurat"
                              onClick={() => {
                                setIsIconModalOpen(false);
                                setSrcIcon(null);
                                setIconImage(null);
                                setCropIcon({
                                  unit: 'px',
                                  width: 70,
                                  height: 70,
                                  x: 0,
                                  y: 0,
                                });
                              }}
                            >
                              <FormattedMessage id="CancelAr" />
                            </ReusableButton>

                            <ReusableButton
                              fullWidth={false}
                              variant="contained"
                              color="#F5F5F5"
                              fontSize="16px"
                              fontWeight="400"
                              padding="12px 25px"
                              height="44px"
                              bgColor="#292D32"
                              fontFamily="Akkurat"
                              onClick={() => getCroppedIcon()}
                            >
                              <FormattedMessage id="SaveCropAr" />
                            </ReusableButton>
                          </div>
                        </div>
                      </div>
                    )}
                    {isError && isError?.icon?.error && (
                      <div style={{ marginTop: '5px' }}>
                        <p className="p-0 m-0 fs-16 fc-EE3232 fw-400 ff-Akkurat">
                          <FormattedMessage id="field is required!" />
                        </p>
                      </div>
                    )}
                  </Col>

                  <Col xs={12} md={6} className="mt-3 pt-15">
                    <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="ImageAr" />{' '}
                      <span
                        style={{
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        *
                      </span>
                    </p>
                    <input
                      ref={imageRef}
                      type="file"
                      name="image"
                      accept=".png, .jpg, .jpeg"
                      disabled={false}
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                    />
                    <div
                      className={`mt-2 ${isError && isError.image.error ? 'imageRedBorder' : 'imageBorder'} flex justify-center align-center`}
                    >
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="items-center cursor-pointer"
                        onClick={handleImageUpload}
                      >
                        {formValue?.image === '' ? (
                          <>
                            <img
                              src={AddBlackColor}
                              alt="icon"
                              style={{ height: '24px', width: '24px' }}
                            />

                            <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                              <FormattedMessage id="AddImageAr" />
                            </p>
                          </>
                        ) : (
                          <>
                            <img
                              src={previewFile?.image}
                              alt="icon"
                              style={{ height: '50px', width: '50px' }}
                            />
                            <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat_Bold">
                              {formValue?.image?.name}
                            </p>
                          </>
                        )}
                      </Stack>
                    </div>
                    {isError && isError?.image?.error && (
                      <div style={{ marginTop: '5px' }}>
                        <p className="p-0 m-0 fs-16 fc-EE3232 fw-400 ff-Akkurat">
                          <FormattedMessage id="field is required!" />
                        </p>
                      </div>
                    )}
                  </Col>

                  <Col xs={12} md={6} className="mt-3 pt-15"></Col>

                  <Col xs={12} md={3} className="mt-3 pt-15">
                    <p className="p-0 m-0 fs-20 fc-292D32 fw-400 ff-Akkurat_Bold">
                      <FormattedMessage id="DescriptionAr" />
                    </p>
                    {!description && (
                      <div
                        className="mt-2 imageBorderWithoutDashed flex justify-center align-center cursor-pointer"
                        onClick={() => setDescription(!description)}
                      >
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center"
                        >
                          <img
                            src={AddBlackColor}
                            alt="icon"
                            style={{ height: '24px', width: '24px' }}
                          />
                          <p className="p-0 m-0 fs-16 fc-292D32 fw-400 ff-Akkurat">
                            <FormattedMessage id="AddDescriptionAr" />
                          </p>
                        </Stack>
                      </div>
                    )}
                  </Col>
                </Row>

                {description && (
                  <>
                    <Col xs={12} md={12} className="mt-2">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="ProductsusedAr" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.productsUsedAr}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'productsUsedAr')
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="BenefitsAr" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.benefitsAr}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'benefitsAr')
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="ProcedureAr" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.procedureAr}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'procedureAr')
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="PrecautionsAr" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.precautionsAr}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'precautionsAr')
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="ThingstoknowAr" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.thingsToKnowAr}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'thingsToKnowAr')
                          }
                        />
                      </div>
                    </Col>
                    <Col xs={12} md={12} className="mt-4">
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat">
                        <FormattedMessage id="AftercaretipsAr" />
                      </p>
                      <div className="mt-2">
                        <Editor
                          editorState={htmlValues?.afterCareTipsAr}
                          toolbar={{
                            options: ['inline', 'list', 'textAlign', 'history'],
                            inline: {
                              options: [
                                'bold',
                                'italic',
                                'underline',
                                'strikethrough',
                              ],
                            },
                          }}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorClassName"
                          onEditorStateChange={(e) =>
                            onEditorStateChange(e, 'afterCareTipsAr')
                          }
                        />
                      </div>
                    </Col>
                  </>
                )}
              </>
            )}

            <Row className="mt-4 items-end m-0 p-0">
              <div className="flex justify-end">
                <Stack direction="horizontal" gap={3} className="items-center">
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#292D32"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="transparent"
                    fontFamily="Akkurat"
                    onClick={() => navigate(superAdminCategory(locale))}
                  >
                    <FormattedMessage id="Cancel" />
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="16px"
                    fontWeight="400"
                    padding="12px 25px"
                    height="44px"
                    bgColor="#292D32"
                    fontFamily="Akkurat"
                    disabled={
                      (formValue?.categoryNameEn !== '' ||
                        formValue?.categoryNameAr !== '') &&
                      formValue?.icon !== '' &&
                      formValue?.image !== ''
                        ? false
                        : true
                    }
                    onClick={() => handleSubmit()}
                    endIcon={
                      addCategoryLoader && (
                        <CircularProgress
                          style={{
                            color: 'white',
                            width: '20px',
                            height: '20px',
                          }}
                        />
                      )
                    }
                  >
                    <FormattedMessage id="Save & Add" />
                  </ReusableButton>
                </Stack>
              </div>
            </Row>
          </>
        </Row>
      </Col>
    </Row>
  );
};

export default AddCategory;
